import React, { memo } from 'react';

import {
    Badge,
    Text,
} from 'reaxl';

function ExplainerCard({ heading, subHeading, children, index, ...rest }) {
    return (
        <div
            className="display-flex gap-1 flex-1"
            key={heading}
            {...rest}
        >
            <div className="margin-1">
                <Badge
                    circle
                    className="bg-blue-darkest"
                >
                    {index + 1}
                </Badge>
            </div>
            <div>
                <Text
                    weight="bold"
                    className="margin-vertical-1"
                    componentClass="div"
                >
                    {heading}
                </Text>
                {subHeading}
                {children}
            </div>
        </div>
    );
}

export default memo(ExplainerCard);
